<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_vi"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="para"><span class="smallcaps">THE CURSED</span>. Copyright © 2007 by Leslie Esdaile Banks. Illustrations copyright © 2007 by Dabel Brothers Productions, LLC. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="linespace"> </p>
<p class="para"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="linespace"> </p>
<p class="para"><em>Illustrations by Chase Conley</em></p>
<p class="linespace"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="linespace"> </p>
<p class="para">Banks, L. A.</p>
<p class="indent-para">The cursed : a vampire huntress legend / L. A. Banks.—1st ed.</p>
<p class="indent-para">     p. cm.</p>
<p class="indent-para">ISBN-13: 978-0-312-35237-0</p>
<p class="indent-para">ISBN-10: 0-312-35237-9</p>
<p class="indent-para">1. Vampires—Fiction. I. Title.</p>
<p class="linespace"> </p>
<p class="para">PS3602.A64C87 2007</p>
<p class="para">813'.6—dc22</p>
<p class="right-para">2007010153</p>
<p class="linespace"> </p>
<p class="para">First Edition: July 2007</p>
<p class="linespace"> </p>
<p class="para">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?05889d3f